










import { Mutations } from '@/ts/store/Constants';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class ImageViewer extends Vue {
    constructor() {
        super();
    }

    get imageBlob(): string {
        return this.$store.getters['Images/getImageBlob'];
    }

    public close() {
        this.$store.commit(Mutations.HIDE_IMAGE_VIEWER, null);
    }
}
